/*
 * Created by: cparaschiv
 * Date: 22.11.2013, 16:45
 */

TS.ns('TS');

(function () {
	TS.PropertyAccessor = new Class(
	/** @lends TS.PropertyAccessor# */
	{

		Extends: TS.Observable,

		events: [
			/**
			 * Fires when the vmonitored value changed.
			 * @event TS.PropertyAccessor#changed
			 */
			'changed'
		],

	    /**
	     * Represents a chain of members
         * @constructor
         * @param {} config
         * @param {} config.dataSource
         * @param {string} config.propertyPath The member path separeted by .
         * @param {function} [config.handler] Function triggered on value change
         * @returns {} 
         */
		initialize: function (config) {
			var me = this;

			me.parent(config);
			Object.append(me, config);
			this._subscriptions = [];

			if (!config.propertyPath) {
				TS.Log.warn('PropertyAccessor: undefined propertyPath');
				return;
			}
			if (!config.dataSource) {
				TS.Log.warn('PropertyAccessor: undefined dataSource');
				return;
			}

			this._createProperties();
			me.hook();

		    // Try auto dispose. If the handler is not provided, we asume that there is no one to dispose this accessor.
			if (!config.handler) {
			    config.dataSource.on(['disposed', 'close'], function () {
			        me.dispose();
			    });
			}
		},

		_createProperties: function () {
			ko.createProperty(this, 'value', this.getPropertyValue());
		},

		_onValueChanged: function (newValue) {
		    if (this.handler) {
		        this.handler(newValue);
		    }
		    this.trigger('changed', newValue);
		},

		getPropertyValue: function () {
			return TS.getPropertyValue(this.dataSource, this.propertyPath);
		},

		setPropertyValue: function (value) {
			TS.setPropertyValue(this.dataSource, this.propertyPath, value);
		},

		hookSubscriptions: function () {
			var me = this,
				ds = me.dataSource,
				parts = (me.propertyPath || '').split('.'),

				propertyChanged = function (newValue) {
					me.unhookSubscriptions();
					newValue = me.getPropertyValue();
					me.hookSubscriptions();
					
					var _onValueChanged = me._onValueChanged;
				    try {
				        me._onValueChanged = function () { };
				        me.value(newValue);
				    } finally {
				        me._onValueChanged = _onValueChanged;
				        me._onValueChanged(newValue);
				    }
				},
				partIndex = 0, partsLength = parts.length,
				part;

			for (partIndex = 0; partIndex < partsLength; partIndex++) {
				part = parts[partIndex];

				if (part.indexOf('()') == part.length - 2) {
					part = part.substr(0, part.length - 2);
				}

				ds = ds[part];

				var s = ko.subscribeIf(ds, propertyChanged, me);
				if (s) {
					ds = ds();
					me._subscriptions.push(s);
				}

				//this part does not exist, no need to continue
				if (typeof ds === 'undefined' || ds === null) {
					break;
				} 
			}
		},

		hook: function () {
			var me = this,
				valueChanged = function (newValue) {
					//avoid stack overflow, if the value is not primitive ko raises the changed event event the object is the same.
				    if (me.settingValue !== undefined && me.settingValue === newValue)
						return;
					try {
					    me.settingValue = newValue;
					me.setPropertyValue(newValue);
					}
					finally {
					    delete me.settingValue;
					}
					me._onValueChanged(newValue);
				};

			me._valueSubscription = me.value.subscribe(valueChanged, me);
			me.hookSubscriptions();
		},

		unhookSubscriptions: function () {
			// dispose subscriptions, will be recreated in _watch* methods
			$.each(this._subscriptions, function () {
				this.dispose();
			});
			this._subscriptions = [];
		},

		unhook: function () {
			this.unhookSubscriptions();
			if (this._valueSubscription) {
				this._valueSubscription.dispose();
				delete this._valueSubscription;
			}
		},

		refresh: function () {
			this.unhook();
			this.value(this.getPropertyValue());
			this.hook();
		},

		dispose: function () {
			this.unhook();
			this.parent();
			this.disposed = true;
		}
	});

})();